import { UrlsSettings } from './urls-settings';

export { UrlsSettings };
